import gql from "graphql-tag";

const UPDATE_HOMEOWNER_TRAFFIC = gql`
  mutation updateHomeownerTraffic($input: HomeownerTrafficUpdateInput!) {
    updateHomeownerTraffic(input: $input) {
      message
      code
    }
  }
`;

export default UPDATE_HOMEOWNER_TRAFFIC;
